/*
* Report pages: component client questions
*/

import * as _ from 'lodash';
import * as React from 'react';
import * as WordWrap from 'word-wrap';

import { Formatters } from '../../../common/formatters';
import * as ReportComponents from '../report-components';

export const Render = ({ registerFunc, refFunc, scrollToFunc, maxTableRowsPerPage = 0, pageTitle = '', className = '', pageConfiguration, pageCount, reportData, appText, ...rest }) => {
    const sectionName = ReportComponents.ReportSectionNames.componentFundingInformation;
    const ReportPageWithRegister = ReportComponents.withPageRegistration(ReportComponents.ReportPageTableData, sectionName, registerFunc, refFunc, undefined); // scrollToFunc);
    const getTableRowKey = (id, secName, tabName = 'data') => ReportComponents.getRowKey(id, secName, tabName);

    const { formData, association, calculations, isHypothetical, inventory, currentOrder, currentOrderChart, percentFunded, yearlySummaryData } = reportData;

    // Configuration
    const maxComponentNameLenWrap = 55;
    const maxComponentQuantityLenWrap = 33;
    const maxComponentLocationLenWrap = 33;
    const reportOptionsGroupComponents = true;
    const reportOptionsGroupComponentsPictureSection = true;

    const chunkSize = (maxTableRowsPerPage > 0) ? maxTableRowsPerPage : _.get(pageConfiguration, 'maxTableRowsPerPage', 15);

    const extendDataItem = (dataItem: any) => {
        const subgroup = _.get(dataItem, 'subgroup', '');

        let invRootCompName = Formatters.getStr(dataItem, 'componentName');
        let invEmbedCompName = Formatters.getStr(dataItem, 'component.name');

        let compName = (invRootCompName !== '') ? invRootCompName : invEmbedCompName;

        let res = {
            subgroup: subgroup, // TODO: refactor away?
            componentName: compName,
            wrappedItemRow: false,
            wrappedItemRow_sort: '',
            appendClientQuestionsRowSpan: true,
        };

        return res;
    };

    const transformDataItems = (dataItems: any[]) => {
        let results: any[] = _(dataItems)
            .map((inv, i) => {
                const extended = extendDataItem(inv);
                const itemCompName = _.trim(Formatters.getStr(inv, 'componentName'));

                const item = {
                    _id: Formatters.getStr(inv, '_id'),
                    componentId: Formatters.getInt(inv, 'componentId'),
                    componentName: itemCompName,
                    componentName_sort: itemCompName.toLowerCase(),
                    quantity: Formatters.getStr(inv, 'quantity'),
                    location: Formatters.getStr(inv, 'location'),
                    clientQuestions: Formatters.getStr(inv, 'clientQuestions'),
                    printClientQuestions: (Formatters.getStr(inv, 'clientQuestions') !== '') ? true : false, // if there are client questions -- print them, per Rob request to force printClientQuestions to on/yes
                    printNote: Formatters.getBool(inv, 'printNote'),
                };

                const res = _.merge({}, item, extended);

                return res;
            })
            .value();

        let resultsExpanded = _.stubArray();
        for (let iItemInd = 0; iItemInd < _.size(results); iItemInd++) {
            let r = results[iItemInd];
            let rItem = _.cloneDeep(r);

            // Component Name wrapping
            const rItemCompName = Formatters.getStr(rItem, 'componentName');
            const rItemCompNameWrapResult = WordWrap(rItemCompName, {
                width: maxComponentNameLenWrap,
                trim: true,
                indent: '',
                cut: false,
            });
            const rItemCompNameWrapSplitResults: any = _.split(rItemCompNameWrapResult, '\n');
            const needCompNameWrapsNum = (_.size(rItemCompNameWrapSplitResults) <= 1) ? 0 : _.size(rItemCompNameWrapSplitResults) - 1;
            const needCompNameWrap = (needCompNameWrapsNum >= 1) ? true : false;

            // Component Quantity wrapping
            const rItemCompQuantity = Formatters.getStr(rItem, 'quantity');
            const rItemCompQuantityWrapResult = WordWrap(rItemCompQuantity, {
                width: maxComponentQuantityLenWrap,
                trim: true,
                indent: '',
                cut: false,
            });
            const rItemCompQuantityWrapSplitResults: any = _.split(rItemCompQuantityWrapResult, '\n');
            const needCompQuantityWrapsNum = (_.size(rItemCompQuantityWrapSplitResults) <= 1) ? 0 : _.size(rItemCompQuantityWrapSplitResults) - 1;
            const needCompQuantityWrap = (needCompQuantityWrapsNum >= 1) ? true : false;

            // Component Location wrapping
            const rItemCompLocation = Formatters.getStr(rItem, 'location');
            const rItemCompLocationWrapResult = WordWrap(rItemCompLocation, {
                width: maxComponentLocationLenWrap,
                trim: true,
                indent: '',
                cut: false,
            });
            const rItemCompLocationWrapSplitResults: any = _.split(rItemCompLocationWrapResult, '\n');
            const needCompLocationWrapsNum = (_.size(rItemCompLocationWrapSplitResults) <= 1) ? 0 : _.size(rItemCompLocationWrapSplitResults) - 1;
            const needCompLocationWrap = (needCompLocationWrapsNum >= 1) ? true : false;

            if (needCompNameWrap || needCompQuantityWrap || needCompLocationWrap) {
                let maxNeedCompWraps: any = _.max([needCompNameWrapsNum, needCompQuantityWrapsNum, needCompLocationWrapsNum]);

                for (let iWrapItemInd = 0; iWrapItemInd <= maxNeedCompWraps; iWrapItemInd++) {
                    let rWrapInvItem = _.cloneDeep(rItem);

                    // Component Name
                    const itemCompNameSort = `${Formatters.getStr(rItem, 'componentName_sort')}-${iItemInd}-${iWrapItemInd}`;
                    _.set(rWrapInvItem, 'componentName_sort', itemCompNameSort);
                    const rWrapInvItemCompName = Formatters.getStr(rItemCompNameWrapSplitResults, `[${iWrapItemInd}]`);
                    if (iWrapItemInd === 0) {
                        _.set(rWrapInvItem, 'componentName', rWrapInvItemCompName);
                    } else {
                        if (needCompNameWrap && rWrapInvItemCompName) {
                            _.set(rWrapInvItem, 'componentName', rWrapInvItemCompName);
                        } else {
                            _.set(rWrapInvItem, 'componentName', '');
                        }
                    }

                    // Component Quantity
                    const rWrapInvItemCompQuantity = Formatters.getStr(rItemCompQuantityWrapSplitResults, `[${iWrapItemInd}]`);
                    if (iWrapItemInd === 0) {
                        _.set(rWrapInvItem, 'quantity', rWrapInvItemCompQuantity);
                    } else {
                        if (needCompQuantityWrap && rWrapInvItemCompQuantity) {
                            _.set(rWrapInvItem, 'quantity', rWrapInvItemCompQuantity);
                        } else {
                            _.set(rWrapInvItem, 'quantity', '');
                        }
                    }

                    // Component Location
                    const rWrapInvItemCompLocation = Formatters.getStr(rItemCompLocationWrapSplitResults, `[${iWrapItemInd}]`);
                    if (iWrapItemInd === 0) {
                        _.set(rWrapInvItem, 'location', rWrapInvItemCompLocation);
                    } else {
                        if (needCompLocationWrap && rWrapInvItemCompLocation) {
                            _.set(rWrapInvItem, 'location', rWrapInvItemCompLocation);
                        } else {
                            _.set(rWrapInvItem, 'location', '');
                        }
                    }

                    _.set(rWrapInvItem, 'wrappedItemRow_sort', `${iItemInd}-${iWrapItemInd}`);
                    _.set(rWrapInvItem, 'wrappedItemRow', (iWrapItemInd >= 1) ? true : false);
                    _.set(rWrapInvItem, 'appendClientQuestionsRowSpan', (iWrapItemInd >= maxNeedCompWraps) ? true : false);

                    resultsExpanded.push(rWrapInvItem);
                }
            } else {
                resultsExpanded.push(rItem);
            }
        }

        return resultsExpanded;
    };

    const buildRowsNew = (data: any[], tableName: string = 'tbl') => {
        const dataItems = _.filter(data, (o) => !Formatters.getBool(o, 'placeholder') && Formatters.getBool(o, 'printClientQuestions'));
        let rows: any = _(dataItems)
            .map((item: any, ind: number, arr: any[]) => {
                let res = _.stubArray();

                const isFirstPage = Formatters.getBool(item, 'group.first');
                const isDisplayItemOnly = Formatters.getBool(item, 'wrappedItemRow');

                const isClientQuestionsRowSpanAppendable = Formatters.getBool(item, 'appendClientQuestionsRowSpan');
                const hasClientQuestions = (Formatters.getStr(item, 'clientQuestions') !== '') ? true : false;

                const canAppendRowSpan = (isClientQuestionsRowSpanAppendable && hasClientQuestions) ? true : false;

                if (isFirstPage && reportOptionsGroupComponents) {
                    const headerRow = (isFirstPage) ? buildGroupHeaderRow(item) : undefined;
                    const hasHeaderRow = (headerRow) ? true : false;

                    if (hasHeaderRow) { res.push(headerRow); }
                }

                res.push(
                    <tr key={getTableRowKey(`${Formatters.getStr(item, '_id')}-${Formatters.getStr(item, 'wrappedItemRow_sort')}`, sectionName, `${tableName}-cfcq-row-component`)}>
                        <td className="text-center">{(!isDisplayItemOnly) ? Formatters.getStr(item, 'componentId') : <span />}</td>
                        <td className="col-ccq-component-name">{Formatters.getStr(item, 'componentName')}</td>
                        <td className="col-ccq-location">{Formatters.getStr(item, 'location')}</td>
                        <td className="col-ccq-quantity">{Formatters.getStr(item, 'quantity')}</td>
                    </tr>
                );

                if (canAppendRowSpan) {
                    res.push(
                        <tr key={getTableRowKey(`${Formatters.getStr(item, '_id')}-${Formatters.getStr(item, 'wrappedItemRow_sort')}-note`, sectionName, `${tableName}-cfcq-row-component-note`)}>
                            <td className="text-center"><span /></td>
                            <td className="col-ccq-question" colSpan={3}>{Formatters.getStr(item, 'clientQuestions')}</td>
                        </tr>
                    );
                }

                return res;
            })
            .value();

        return _.flattenDeep(rows);
    };

    const transformedInvItems = transformDataItems(inventory);
    const invSort = (reportOptionsGroupComponents) ?
        _.orderBy(transformedInvItems, ['subgroup', 'componentId', 'componentName_sort', 'wrappedItemRow_sort'], ['asc', 'asc', 'asc', 'asc'])
        : _.orderBy(transformedInvItems, ['componentId', 'componentName_sort', 'wrappedItemRow_sort'], ['asc', 'asc', 'asc']);

    // GROUP ITEMS BY SUBGROUP
    const grouped = _(invSort)
        .groupBy('subgroup')
        .toPairs()
        .value();

    const subgroups = _.flattenDeep(
        grouped.map((g, gInd) => {
            // const sg = _.find(association.inventorySubgroups, ['groupCode', g[0]]);
            const sg = (_.find(association.inventorySubgroups, ['groupCode', g[0]])) ? _.find(association.inventorySubgroups, ['groupCode', g[0]]) : _.find(association.inventorySubgroups, ['groupCode', _.toString(_.parseInt(g[0]))]);
            if (!sg || !sg.groupCode) { return null; }

            const items = g[1].map((i, iInd, iArr) => {
                return _.merge({}, i, {
                    group: {
                        first: (iInd === 0) ? true : false,
                        last: (iInd === _.size(iArr) - 1) ? true : false,
                        groupInd: iInd,
                        subgroupTitle: sg.title,
                        subTotals: {}
                    }
                });
            });

            return items;
        })
    );

    const buildGroupHeaderRow = (itemData: any) => {
        const groupSubgroupCode = Formatters.getStr(itemData, 'subgroup');
        const groupTitle = `${Formatters.getStr(itemData, 'group.subgroupTitle')} (${groupSubgroupCode})`;

        const result = (
            <tr key={getTableRowKey(`summary-row-header-subgroup-${groupSubgroupCode}`, sectionName, 'tbl-cfcq-group-header')} className="pdf-data-table-summary-row">
                <td colSpan={4} className="pdf-data-table-summary-row-colspan pdf-data-table-group-header-row text-left">{groupTitle}</td>
            </tr>
        );

        return result;
    };

    // CHUNK DATA/TABLES TO PAGES
    const subgroupsSorted = (reportOptionsGroupComponents) ? _.orderBy(subgroups, ['group.subgroupTitle', 'group.groupInd'])
        : _.orderBy(subgroups, ['componentId', 'wrappedItemRow_sort']);

    let tableRows = buildRowsNew(subgroupsSorted, 'buildRows-new');

    const assocContact = _.get(association, 'contact');
    const assocClient = _.get(association, 'client');

    const contactName = Formatters.composeClientContactLetter(assocContact, true, true);
    const clientName = Formatters.getStr(assocClient, 'name');

    let reportSubHeaderText = `${contactName} - ${clientName}`;

    const contactPhone = (Formatters.getStr(assocContact, 'phone') !== '') ? Formatters.getStr(assocContact, 'phone') : Formatters.getStr(assocClient, 'phone');
    if (contactPhone) { reportSubHeaderText += ' - ' + Formatters.formatPhoneNumberNational(contactPhone); }

    const pageHeader = (
        <div>
            <div>{pageTitle}: {Formatters.getStr(association, 'associationId')} <i>{Formatters.getStr(association, 'name')}</i></div>
            <div className="assoc-contact">{reportSubHeaderText}</div>
        </div>);

    let pagesNew;
    if (_.size(tableRows) > 0) {
        pagesNew = _(tableRows)
            .chunk(chunkSize)
            .map((chunkItems, chunkInd, chunkInputArr) => {
                const keyPrefix = `chunkInd-ccq-${chunkInd}`;

                const headRow = (
                    <tr>
                        <th className="col-ccq-id">{appText('page.component-client-questions.grid-column-headers.id')}</th>
                        <th className="col-ccq-component-name">{appText('page.component-client-questions.grid-column-headers.component-name')}</th>
                        <th className="col-ccq-location">{appText('page.component-client-questions.grid-column-headers.location')}</th>
                        <th className="col-ccq-quantity">{appText('page.component-client-questions.grid-column-headers.quantity')}</th>
                    </tr>
                );

                const chunkPage = (
                    <div key={getTableRowKey(`cfcq-page-keyPrefix-${keyPrefix}`, sectionName, 'tbl-cfcq-chunk-page')} className="pdf-data-table-component-client-questions-chunkpage">
                        <ReportPageWithRegister
                            className={className}
                            classNameTable="pdf-data-table-component-client-questions"
                            footerData={reportData}
                            pageIndex={chunkInd}
                            pageTitle={pageHeader}
                            showFooter={true}
                            tbodyRows={chunkItems}
                            theadRow={headRow}
                            totalPageCount={pageCount}
                        />
                    </div>
                );

                return chunkPage;
            })
            .value();
    } else {
        // We have no valid inventory to show. Just show the report header and a niced message.
        pagesNew = (
            <ReportPageWithRegister
                className={className}
                classNameTable="pdf-data-table-component-client-questions"
                footerData={reportData}
                pageIndex={0}
                pageTitle={pageHeader}
                showFooter={true}
                tbodyRows={undefined}
                theadRow={undefined}
                totalPageCount={1}
            >
                <div>
                    {...rest.children}
                </div>
            </ReportPageWithRegister>
        );
    }

    return (
        <div className="pdf-data-table-component-client-questions-pages-wrapper">
            {pagesNew}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/report/pdf/pages/report-page-component-client-questions.tsx